<script setup lang="ts">
import { GlassButton } from '~/components/GlassButton';

import IconMaterialSymbolsLightVolumeOff from '~icons/material-symbols-light/volume-off';
import IconMaterialSymbolsLightVolumeUp from '~icons/material-symbols-light/volume-up';

interface ShortsHeaderProps {
	isGlobalMuted: boolean;
	hideHeaderControls?: boolean;
}

withDefaults(defineProps<ShortsHeaderProps>(), {
	hideHeaderControls: false
});

defineEmits<{
	(e: 'toggle-mute'): void;
	(e: 'close'): void;
}>();
</script>

<template>
	<div class="absolute left-3 top-3 z-50 hidden items-center gap-2 lg:flex">
		<slot name="desktop-mode-toggle" />
	</div>

	<div
		v-if="!hideHeaderControls"
		class="absolute right-5 top-5 z-50 hidden items-center gap-2 md:flex"
	>
		<GlassButton
			variant="action"
			size="sm"
			:aria-label="isGlobalMuted ? 'Ativar som' : 'Desativar som'"
			@click="$emit('toggle-mute')"
		>
			<IconMaterialSymbolsLightVolumeOff
				v-if="isGlobalMuted"
				class="size-5 text-white"
			/>
			<IconMaterialSymbolsLightVolumeUp v-else class="size-5 text-white" />
		</GlassButton>
	</div>
</template>
